import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import localeData from 'dayjs/plugin/localeData'
import relativeTime from 'dayjs/plugin/relativeTime'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import 'dayjs/locale/th'
import 'dayjs/locale/en'
import 'dayjs/locale/zh-cn'
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(localeData)
dayjs.extend(relativeTime)
dayjs.extend(localizedFormat)

const momenttimethai = (data) => {
  // return (dayjs(data).tz('Pacific/Kiritimati').locale('th').format('LT'))
  return (dayjs(data).add(7, 'hour').tz('Asia/Bangkok').locale('th').format('LT'))
}
const momentdatethai = (data) => {
  // return dayjs(data).tz('Pacific/Kiritimati').locale('th').format('ll')
  return dayjs(data).add(543, 'year').tz('Asia/Bangkok').locale('th').format('ll')
}
export default {
  momenttimethai,
  momentdatethai
}



// WEBPACK FOOTER //
// ./src/services/momentthai.js